export const GA_TRACKING_ID = 'G-ZGEMDCK6KG';

/** Log page views to Google Analytics */
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

/** Generic event tracker */
export const event = ({ action, category, label, value, ...customParams }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
      ...customParams,
    });
  }
};

export const trackLoginSuccess = (userEmail) => {
  event({
    action: 'login',
    category: 'Authentication',
    label: userEmail || 'owner_login',
    send_to: GA_TRACKING_ID,
  });
};

export const trackSignupSuccess = (userEmail) => {
  event({
    action: 'sign_up',
    category: 'Authentication',
    label: userEmail || 'owner_signup',
    send_to: GA_TRACKING_ID,
  });
  event({
    action: 'generate_lead',
    category: 'Conversion',
    label: 'owner_registration',
    send_to: GA_TRACKING_ID,
  });
};

export const trackBranchPayment = (paymentData = {}) => {
  event({
    action: 'purchase',
    category: 'Ecommerce',
    label: paymentData.orderId || 'branch_payment',
    value: paymentData.amount || 0,
    currency: 'INR',
    send_to: GA_TRACKING_ID,
  });
};